import React from 'react';
import { MapPin } from 'lucide-react';
import { serviceAreas } from '../mock';

export const ServiceAreas = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#0B7CB5]/5">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <MapPin className="w-10 h-10 text-[#0B7CB5]" />
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Serving the <span className="text-[#0B7CB5]">Greater Richmond Area</span>
            </h2>
          </div>
          <p className="text-xl text-gray-600 mb-12">
            Professional cleaning services throughout Richmond and surrounding communities
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {serviceAreas.map((area, index) => (
              <div
                key={index}
                className="flex items-center space-x-2 bg-white px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-all duration-200 hover:-translate-y-1 group"
              >
                <MapPin className="w-5 h-5 text-[#0B7CB5] group-hover:scale-110 transition-transform duration-200" />
                <span className="font-medium text-gray-800">{area}</span>
              </div>
            ))}
          </div>

          <p className="text-gray-600 text-lg">
            ...and surrounding communities
          </p>
        </div>
      </div>
    </section>
  );
};